import { FC } from 'react';
import { Line } from 'recharts';
import { MetricChartFrame } from './MetricChartFrame';
import { HighlightDot } from './HighlightDot';
import { MetricHistoryPoint } from '../useMetricHistory';

interface Props {
  data: MetricHistoryPoint[];
  label: string;
  unit?: string;
  decimals: number;
  color: string;
  /** YYYY-MM-DD — giorno da evidenziare (cella cliccata) */
  highlightDate?: string | null;
  height?: number;
}

/** Chart linea generico per metriche continue (RI, CMJ, HRV, HRrest). */
export const MetricLineChart: FC<Props> = ({
  data,
  label,
  unit,
  decimals,
  color,
  highlightDate,
  height,
}) => {
  const renderDot = (dotProps: any) => (
    <HighlightDot {...dotProps} color={color} highlightDate={highlightDate} />
  );

  return (
    <MetricChartFrame
      data={data}
      height={height}
      highlightDate={highlightDate}
      highlightColor={color}
      as="line"
      yAxisDomain={['auto', 'auto']}
      tooltipFormatter={(value) => [
        `${Number(value).toFixed(decimals)}${unit ? ` ${unit}` : ''}`,
        label,
      ]}
    >
      <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2} dot={renderDot} />
    </MetricChartFrame>
  );
};
